import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "bg-white rounded-xl shadow-lg w-[640px] max-h-[80vh] flex flex-col overflow-hidden" }
const _hoisted_2 = { class: "flex justify-between items-center px-6 py-4 border-b border-gray-200" }
const _hoisted_3 = { class: "text-base font-semibold" }
const _hoisted_4 = { class: "overflow-y-auto flex-1" }
const _hoisted_5 = { class: "w-full text-sm text-left" }
const _hoisted_6 = { class: "bg-gray-100 sticky top-0" }
const _hoisted_7 = { class: "px-6 py-3 w-6" }
const _hoisted_8 = { class: "px-6 py-3" }
const _hoisted_9 = { class: "px-6 py-3 text-right" }
const _hoisted_10 = { class: "px-6 py-3" }
const _hoisted_11 = { class: "px-6 py-3" }
const _hoisted_12 = { class: "px-6 py-3 text-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    id: "modal-v3",
    visible: _ctx.visible,
    "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => (_ctx.visible = $event)),
    modal: "",
    blockScroll: "",
    showHeader: false,
    style: { width: '600px' }
  }, {
    default: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("h2", _hoisted_3, _toDisplayString(_ctx.$t("codReconcile.detail.totalStt", { count: _ctx.sttList.length })), 1),
          _createVNode("button", {
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args))),
            class: "w-6 h-6 flex items-center justify-center rounded-full hover:bg-gray-100"
          }, " ✕ ")
        ]),
        _createVNode("div", _hoisted_4, [
          _createVNode("table", _hoisted_5, [
            _createVNode("thead", _hoisted_6, [
              _createVNode("tr", null, [
                _createVNode("th", _hoisted_7, _toDisplayString(_ctx.$t("codReconcile.list.no")), 1),
                _createVNode("th", _hoisted_8, _toDisplayString(_ctx.$t("codReconcile.dailyDeposit.noStt")), 1),
                _createVNode("th", _hoisted_9, _toDisplayString(_ctx.$t("codReconcile.dailyDeposit.nominal")), 1)
              ])
            ]),
            _createVNode("tbody", null, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sttList, (item, index) => {
                return (_openBlock(), _createBlock("tr", {
                  key: index,
                  class: "border-t border-gray-100 font-light"
                }, [
                  _createVNode("td", _hoisted_10, _toDisplayString(index + 1), 1),
                  _createVNode("td", _hoisted_11, _toDisplayString(item.sttNo), 1),
                  _createVNode("td", _hoisted_12, _toDisplayString(_ctx.formatCurrency(item.amount)), 1)
                ]))
              }), 128))
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}